import React from 'react';
import { FaTasks } from 'react-icons/fa';
import { ResourceInIncident } from '../../hooks/resourceInIncidentHooks';
import { WorkAssignment } from '../../hooks/workAssignmentHooks';

interface WorkAssignmentSectionProps {
  resource: ResourceInIncident;
  workAssignments: WorkAssignment[];
}

const WorkAssignmentSection: React.FC<WorkAssignmentSectionProps> = ({
  resource,
  workAssignments,
}) => {
  // Find work assignments that contain this resource
  const resourceWorkAssignments = workAssignments.filter((wa) => {
    const resourceSetId = resource.resource_set_id;
    const hasResource =
      Array.isArray(wa.resource_sets) &&
      wa.resource_sets.includes(resourceSetId);
    return hasResource;
  });

  // Show new multi-assignment view if any assignments found through resource_sets
  if (resourceWorkAssignments.length > 0) {
    return (
      <div className="mb-2">
        <div className="bg-light rounded p-2">
          <div className="d-flex align-items-center justify-content-between mb-1">
            <div className="d-flex align-items-center gap-2">
              <FaTasks size={12} className="text-primary" />
              <span className="small text-dark">
                <strong>
                  Work Assignment
                  {resourceWorkAssignments.length > 1 ? 's' : ''}
                </strong>
              </span>
            </div>
          </div>
          <div className="ms-3">
            {resourceWorkAssignments.map((wa) => (
              <div
                key={wa.work_assignment_id}
                className="text-dark small fw-semibold"
              >
                {wa.work_assignment ||
                  `Assignment ${workAssignments.indexOf(wa) + 1}`}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Fallback to old single assignment view for backward compatibility
  if (resource.work_assignment_id && workAssignments.length > 0) {
    const workAssignment = workAssignments.find(
      (wa) => wa.id === resource.work_assignment_id
    );
    if (!workAssignment) {
      // If work assignment not found, show the ID as fallback
      return (
        <div className="mb-2">
          <div className="bg-light rounded p-2">
            <div className="d-flex align-items-center gap-2">
              <FaTasks size={12} className="text-primary" />
              <span className="small text-dark">
                <strong>Work Assignment ID:</strong>{' '}
                {resource.work_assignment_id}
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="mb-2">
        <div className="bg-light rounded p-2">
          <div className="d-flex align-items-center justify-content-between mb-1">
            <div className="d-flex align-items-center gap-2">
              <FaTasks size={12} className="text-primary" />
              <span className="small text-dark">
                <strong>Work Assignment</strong>
              </span>
            </div>
          </div>
          <div className="ms-3">
            <div className="text-dark small fw-semibold">
              {workAssignment.work_assignment ||
                `Assignment ${workAssignments.indexOf(workAssignment) + 1}`}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default WorkAssignmentSection;
